module.exports = __webpack_public_path__ + "img/img1.3e665e05.jpg";